import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-classifier",
  "use": "foquz-icon-question-classifier-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-classifier\"><path d=\"M18 5a2 2 0 104 0 2 2 0 00-4 0zm0 0h-5m5 8a2 2 0 104 0 2 2 0 00-4 0zm0 0h-3a2 2 0 01-2-2M8 5a2 2 0 11-4 0 2 2 0 014 0zm0 0h5m5 16a2 2 0 104 0 2 2 0 00-4 0zm0 0h-3a2 2 0 01-2-2v-8m0-6v6\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol